// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/superAdmin';
// import router from "../../../router/index";

const state = {
    // Additional state if needed
    getBotQNA: '',
    QNAById: '',
}

const mutations = {
    SET_BOT_QNA_DATA(state, data) {
        state.getBotQNA = data
    },
    SET_QNA_BY_ID(state, data) {
        state.QNAById = data
    },
}

const actions = {
    // Additional actions if needed
      getBotQNA({ commit }) {
            // return
            return new Promise((resolve, reject) => {
                axios
                    .get(axios.defaults.baseURL + apis.GET_BOT_QNA, {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                            "ngrok-skip-browser-warning": "69420",
                        },
                    })
                    .then((res) => {
                        console.log('getBotQNA---res !!', res)
                        resolve(res)
                        if(Array.isArray(res.data.data)){
                            commit('SET_BOT_QNA_DATA', res.data.data)
                        }
                        else{
                           commit('SET_BOT_QNA_DATA', res.data.message)
                        }
                    })
                    .catch((err) => {
                        reject(err)
                        console.log('getBotQNA err', err)
                    })
            })
    },

    getQNAById({ commit }, id) {
        // return
        // return new Promise((resolve, reject) => {
            axios
                .get(axios.defaults.baseURL + apis.FIND_BOT_QNA_BY_ID + id, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('getQNAById---res !!', res)
                    if(res.data.data){
                        commit('SET_QNA_BY_ID', res.data.data)
                    }
                    else{
                       commit('SET_QNA_BY_ID', res.data.message)
                    }
                })
                .catch((err) => {
                    console.log('getQNAById err', err)
                })
        // })
    },

    addQNA({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("question", payload.question);
        formData.append("answer", payload.answer);
        
        return new Promise((resolve, reject) => {
            axios
                .post(axios.defaults.baseURL + apis.ADD_BOT_QNA, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("addQNA res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/all-enquiries")
                    dispatch('getBotQNA')
                })
                .catch((err) => {
                    console.log("addQNA err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },

    editQNA({dispatch}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("question", payload.question);
        formData.append("answer", payload.answer);
        
        return new Promise((resolve, reject) => {
            axios
                .put(axios.defaults.baseURL + apis.UPDATE_BOT_QNA + payload.id, formData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log("editQNA res", res);
                    resolve(res);
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    // router.push("/my-enquiries")
                    dispatch('getBotQNA')
                })
                .catch((err) => {
                    console.log("editQNA err", err);
                    reject(err);
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                });
        });
    },


    deleteQNAById({dispatch }, payload) {
        // return
        return new Promise((resolve, reject) => {
            axios
                .get(axios.defaults.baseURL + apis.DELETE_BOT_QNA + payload.id, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "ngrok-skip-browser-warning": "69420",
                    },
                })
                .then((res) => {
                    console.log('deleteQNAById---res !!', res)
                    resolve(res)
                    dispatch("checkErrorAndSendToast", [
                        res.data.message,
                        "success",
                    ]);
                    dispatch('getBotQNA')
                })
                .catch((err) => {
                    reject(err)
                    console.log('deleteQNAById err', err)
                    dispatch("checkErrorAndSendToast", [
                        err.response,
                        "error",
                    ]);
                })
        })
    },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };